import React, { useState } from 'react';
import styled from 'styled-components';
import Trans from 'next-translate/Trans';
import useTranslation from 'shared/hooks/useTranslation';
import Header from 'shared/components/Header';
import Section from 'shared/components/Section';
import AccordionProvider from 'shared/components/Accordion/AccordionProvider';
import { Collapse, Toggle } from 'shared/components/Accordion';
import AccordionCard from 'shared/components/Accordion/AccordionCard';
import COMPANY_DATA from 'config/companyData';
import Email from 'shared/components/Email';
import AccordionConfig from './AccordionConfig';

const { COMPANY_NAME, COMPANY_STREET, COMPANY_ZIP_CODE, COMPANY_ASSETS, BOK_EMAIL, PHONE } = COMPANY_DATA;

const StyledHeader = styled(Header)`
  font-size: 1.8rem;
  margin: 0 0 4rem 0;

  @media ${({ theme }) => theme.DEVICE.LG} {
    margin: 0 0 6rem 0;
    font-size: 2.8rem;
  }
`;

const AccordionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 156rem;
  width: 100%;
`;

const ContactWrapper = styled.div`
  font-size: 1.6rem;
  padding-bottom: 3.2rem;

  ${({ theme }) => theme.MEDIA.MD} {
    font-size: 1.8rem;
    margin: 0 auto;
    max-width: 80rem;
    padding: 3.2rem;
    padding-top: 0;
  }
`;

function SaInfo(): JSX.Element {
  const { t } = useTranslation('contactPage');

  const [activeEventKey, setActiveEventKey] = useState<number | null>(0);
  const [show, setShow] = useState<boolean>(false);

  return (
    <Section>
      <StyledHeader>Informacje dla akcjonariuszy</StyledHeader>
      <ContactWrapper>
        <p>
          <b>{COMPANY_NAME}</b>
        </p>
        <p>
          {COMPANY_STREET}, {COMPANY_ZIP_CODE}
        </p>
        <p>NIP: 8971854393</p>
        <p>REGON: 369980751</p>
        <p>KRS: 0000737597</p>
        <p>{t('contact.court')}</p>
        <p>
          <Trans
            i18nKey="contactPage:contact.shareCapital"
            values={{
              asset: COMPANY_ASSETS,
            }}
            fallback="contactPageEN:contact.shareCapital"
          />
        </p>
        <p>
          {t('contact.mail')}: <Email email={BOK_EMAIL} setVisible={setShow} visible={show} />
        </p>
        <p>
          {t('contact.phone')}: <a href={`tel: +48 ${PHONE}`}>+48 {PHONE}</a>
        </p>
      </ContactWrapper>
      <AccordionsWrapper>
        <AccordionProvider activeEventKey={activeEventKey} onToggle={setActiveEventKey}>
          {AccordionConfig.map(({ header, body }, index) => (
            <AccordionCard key={header}>
              <Toggle element={AccordionCard.Header} eventKey={index}>
                <AccordionCard.Title>{header}</AccordionCard.Title>
              </Toggle>
              <Collapse eventKey={index} element={AccordionCard.Body}>
                {body}
              </Collapse>
            </AccordionCard>
          ))}
        </AccordionProvider>
      </AccordionsWrapper>
    </Section>
  );
}

export default SaInfo;
